module.exports = __webpack_public_path__ + "img/3-en.2a9bf18a.jpg";